module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.$style.root
  }, [(_vm.userIcon) ? _c('img', {
    staticClass: "event-header event-icon",
    attrs: {
      "src": _vm.userIcon
    }
  }) : _c('icon', {
    staticClass: "event-header event-icon",
    attrs: {
      "name": _vm.icon
    }
  }), _c('div', {
    staticClass: "title event-header"
  }, [(_vm.title) ? _c('markdown', {
    staticClass: "markdown",
    attrs: {
      "source": _vm.title
    }
  }) : _vm._e(), _vm._l((_vm.badges), function(badge, idx) {
    return _c('b-badge', {
      key: idx,
      staticClass: "ml-2",
      attrs: {
        "variant": badge.variant || "danger"
      }
    }, [_vm._v(_vm._s(badge.text))])
  })], 2), _c('span', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip",
      value: (_vm.getFullDate(_vm.created)),
      expression: "getFullDate(created)"
    }],
    staticClass: "event-header"
  }, [_vm._v(" " + _vm._s(_vm.$t('fn.datetime', {
    timestamp: _vm.created
  })))]), (_vm.created !== _vm.updated && _vm.updated && _vm.created) ? _c('span', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip",
      value: (_vm.getFullDate(_vm.updated)),
      expression: "getFullDate(updated)"
    }],
    staticClass: "event-header"
  }, [_vm._v(" " + _vm._s(_vm.$t('fn.datetime', {
    timestamp: _vm.updated
  })))]) : _vm._e(), _c('div', {
    staticClass: "content"
  }, [(_vm.content && (!_vm.preview || !_vm.preview.type) && !_vm.customPreview) ? _c('markdown', {
    attrs: {
      "source": _vm.content
    }
  }) : _vm._e(), _vm._t("content"), (_vm.component) ? _vm._t("component", [(_vm.component.name === 'CampaignTargetPopup') ? [(_vm.component.data.target.old) ? _c('campaign-target-popup', {
    staticClass: "inline-block",
    attrs: {
      "target": _vm.component.data.target.old,
      "target_change_status": "applied"
    }
  }) : _vm._e(), (_vm.component.data.target.new) ? _c('campaign-target-popup', {
    staticClass: "inline-block ml-1",
    attrs: {
      "target": _vm.component.data.target.new,
      "target_change_status": "pending"
    }
  }) : _vm._e()] : _vm._e()]) : _vm._e()], 2), (_vm.files.length > 0) ? _c('div', [_c('file-gallery', {
    attrs: {
      "files": _vm.files
    }
  })], 1) : _vm._e(), (_vm.preview && _vm.preview.type) ? _c('div', {
    staticClass: "row preview"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('creative-preview-scaled', {
    attrs: {
      "creative": _vm.preview,
      "facebookPage": _vm.preview.facebookPage,
      "landingPage": _vm.preview.landingPage,
      "disabledButtons": false,
      "isTimeline": true,
      "mobilePreview": true
    }
  })], 1)]) : _vm._e(), ((!_vm.preview || !_vm.preview.type) && _vm.customPreview) ? _c('div', {
    staticClass: "row preview"
  }, [_c('custom-preview', {
    attrs: {
      "preview": _vm.customPreview
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-18ead9c9"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/gotu-vue-common/src/components/timeline/events/default/Default.vue
// module id = 2009
// module chunks = 1